import { NotifyHelper } from "../../../helpers/toast";
import { eKeHoachToanKhoaActionsObj } from "../../action-types/ke-hoach/IKeHoachToanKhoaActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const keHoachToanKhoaActions = {
    ...generateActions(eKeHoachToanKhoaActionsObj, "KE_HOACH_TOAN_KHOA"),
    ...generateActionForKey(eKeHoachToanKhoaActionsObj, "KE_HOACH_TOAN_KHOA", "UPDATE_SUCCESS", () => {
        NotifyHelper.Success("Thành công");
    }),
    ...generateActionForKey(eKeHoachToanKhoaActionsObj, "KE_HOACH_TOAN_KHOA", "DELETE_SUCCESS", () => {
        NotifyHelper.Success("Thành công");
    }),
    ...generateActionForKey(eKeHoachToanKhoaActionsObj, "KE_HOACH_TOAN_KHOA", "DELETE_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
    ...generateActionForKey(eKeHoachToanKhoaActionsObj, "KE_HOACH_TOAN_KHOA", "UPDATE_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
    ...generateActionForKey(eKeHoachToanKhoaActionsObj, "KE_HOACH_TOAN_KHOA", "LOAD_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
    ...generateActionForKey(eKeHoachToanKhoaActionsObj, "KE_HOACH_TOAN_KHOA", "CREATE_LOP_TC_AUTO_SUCCESS", () => {
        NotifyHelper.Success("Tạo lớp tín chỉ tự động thành công");
    }),
    ...generateActionForKey(eKeHoachToanKhoaActionsObj, "KE_HOACH_TOAN_KHOA", "CREATE_LOP_TC_AUTO_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
}